<div
  class="errortextcolor mb-6 flex items-center gap-3 rounded-[12px] border border-red-400 bg-red-100 px-4 py-2"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="2em"
    height="2em"
    viewBox="0 0 512 512"
  >
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M256 42.667c117.803 0 213.334 95.53 213.334 213.333S373.803 469.334 256 469.334S42.667 373.803 42.667 256S138.197 42.667 256 42.667m48.918 134.25L256 225.836l-48.917-48.917l-30.165 30.165L225.835 256l-48.917 48.918l30.165 30.165L256 286.166l48.918 48.917l30.165-30.165L286.166 256l48.917-48.917z"
    />
  </svg>
  <div class="text-left">
    <h2 class="text-[16px] font-semibold text-red-600">
      {{ errorTitle() }}
    </h2>
    <p class="text-[10px] font-light text-red-500 lg:text-[12px]">
      {{ errorMessage() }}
    </p>
  </div>
</div>
